export class TypeDelaisDivers {

  public receptCandidatures: string;

  public receptionOffres: string;

  constructor() {
    this.receptCandidatures = '';
    this.receptionOffres = '';

  }
}
